import { motion } from "framer-motion";
import { fadeUp, fade, stagger } from "../animations";

export default function Contact() {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fade}
      className="max-w-5xl mx-auto px-6 py-16 space-y-16"
    >
      {/* ================= HEADER ================= */}
      <motion.div variants={fadeUp}>
        <h2 className="text-2xl font-semibold mb-4 text-yellow-300">
          Contact Me
        </h2>
        <p className="text-gray-400 max-w-2xl">
          Interested in working together or have a project idea?  
          I’d love to hear from you.
        </p>
      </motion.div>

      {/* ================= CONTENT ================= */}
      <motion.div
        variants={stagger}
        className="grid md:grid-cols-2 gap-12"
      >
        {/* LEFT – CONTACT INFO */}
        <motion.div variants={fadeUp} className="text-gray-400 space-y-4">
          <h3 className="font-semibold text-white text-lg">
            Let’s work together
          </h3>

          <p>
            Open to opportunities as a
            <span className="text-white"> Full Stack Developer, Python/Flask Developer, </span>
            <span className="text-white">AI/ML Engineer</span>, or
            <span className="text-white"> Flutter Developer</span>.
          </p>

          <div className="space-y-2">
            <p>📧 <span className="text-white">jeevithadhanvi@gmail.com</span></p>
            <p>📞 <span className="text-white">+91 91648 41155</span></p>
            <p>
              🔗{" "}
              <a
                href="https://www.linkedin.com/in/jeevitha-r-779815233"
                target="_blank"
                rel="noreferrer"
                className="text-blue-400 hover:underline"
              >
                LinkedIn Profile
              </a>
            </p>
          </div>

          {/* Resume Button */}
          <motion.a
            whileHover={{ scale: 1.05 }}
            href="/Jeevitha_R_Resume.pdf"
            download
            className="inline-block mt-4 px-6 py-3 rounded-full border border-blue-400 text-blue-300"
          >
            Download Resume
          </motion.a>
        </motion.div>

        {/* RIGHT – CONTACT FORM */}
        <motion.form
          variants={fadeUp}
          action="https://formsubmit.co/jeevithadhanvi@gmail.com"
          method="POST"
          className="bg-[#0b1020] p-6 rounded-xl border border-white/10 space-y-4"
        >
          {/* FormSubmit settings */}
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_template" value="table" />

          <input
            type="text"
            name="name"
            required
            placeholder="Your Name"
            className="w-full p-3 rounded bg-black/40 border border-white/10 text-white focus:outline-none focus:border-blue-400"
          />

          <input
            type="email"
            name="email"
            required
            placeholder="Your Email"
            className="w-full p-3 rounded bg-black/40 border border-white/10 text-white focus:outline-none focus:border-blue-400"
          />

          <textarea
            name="message"
            required
            rows="4"
            placeholder="Your Message"
            className="w-full p-3 rounded bg-black/40 border border-white/10 text-white focus:outline-none focus:border-blue-400"
          ></textarea>

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            type="submit"
            className="w-full py-3 rounded-full bg-gradient-to-r from-blue-400 to-yellow-300 text-black font-semibold"
          >
            Send Message
          </motion.button>
        </motion.form>
      </motion.div>

      {/* ================= CTA ================= */}
      <motion.div
        variants={fadeUp}
        className="text-center bg-gradient-to-r from-[#1b254b] to-[#050814] p-10 rounded-2xl border border-yellow-400/30"
      >
        <h3 className="text-xl font-semibold mb-3">
          Ready to start a conversation?
        </h3>
        <p className="text-gray-400 mb-6">
          Whether it’s a job opportunity, freelance project, or collaboration —
          I’m just one message away.
        </p>

        <a
          href="mailto:jeevithadhanvi@gmail.com"
          className="inline-block px-8 py-3 rounded-full bg-gradient-to-r from-blue-400 to-yellow-300 text-black font-semibold"
        >
          Email Me Directly
        </a>
      </motion.div>
    </motion.section>
  );
}
